export default "__VITE_ASSET__678df688__"